export enum estadoEquipo {
    EnServicio = 0,
    FueraDeServicio = 1,
    Limpieza = 2,
    NoAplica = 3,
    Desvinculado = 4
}